"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isResultNonReactComponent;
function isResultNonReactComponent(reactElementOrRouterResult) {
  return !!(reactElementOrRouterResult.renderedHtml || reactElementOrRouterResult.redirectLocation || reactElementOrRouterResult.error);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-on-rails/node_package/lib/isCreateReactElementResultNonReactComponent.js
// module id = 160
// module chunks = 0